
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Variables from '../global';

function Header(){
    const [menuIsOpen,setMenuIsOpen] = useState(false);
    return (
        <header className="header">
            <div className="user" onClick={()=>setMenuIsOpen(state=> !state)} onBlur={()=>setMenuIsOpen(false)}>
                <img className="avatar" src={`${Variables.api_url}/images/settings/logo_icon.png`}/>
            </div>
            <div className={`menu${menuIsOpen?' open':''}`}>
                <ul>
                    <li>
                        <Link to='/settings'>Tənzimləmələr</Link>
                    </li>
                    <hr/>
                    <li>
                        <Link to='/logout'>Çıxış</Link>
                    </li>
                </ul>
            </div>
        </header>
    )
}

export default Header;